module.exports = __webpack_public_path__ + "static/media/callout.637af390.svg";